function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 20.064c0 1.051-.971 1.863-2.158 1.931L5.679 22H5.32c-1.189 0-2.204-.746-2.312-1.769L3 20.09V18h-.502a1.499 1.499 0 01-.978-.407l-.11-.113a1.665 1.665 0 01-.406-.98l-.003-.153v-3.938a3.615 3.615 0 01.994-2.41L1.86 10a1.395 1.395 0 01-.941-.345 1.23 1.23 0 01-.412-.784L.5 8.741v-.35c0-.735.601-1.319 1.35-1.385L1.992 7h1.387l.178-.595.411-1.271c.077-.309.195-.606.358-.895.252-.421.622-.76 1.085-.981A3.226 3.226 0 016.646 3l.203.006h10.312a3.253 3.253 0 011.491.261c.442.213.811.55 1.071.984.117.208.213.427.283.645l.442 1.52.174.584h1.386c.765 0 1.412.54 1.485 1.255l.007.136v.35c0 .349-.153.678-.419.914a1.386 1.386 0 01-.79.34l-.145.005h-.139c.541.565.9 1.327.979 2.178l.014.234v3.922c.012.422-.134.834-.408 1.146-.245.279-.576.459-.943.507l-.16.013H21v2.064c0 1.05-.958 1.863-2.13 1.931l-.162.005h-.416c-1.19 0-2.2-.768-2.286-1.794L16 20.064V18H8v2.064zM19.774 10l.155.01c1.081.117 1.95 1.055 2.06 2.246l.011.172v3.92l-.004.108a.66.66 0 01-.155.364c-.08.09-.18.15-.286.17l-.08.01H2.512l-.074-.01a.529.529 0 01-.278-.17.661.661 0 01-.156-.357l-.004-.103v-3.771l.001-.174c.05-1.266.941-2.284 2.07-2.404L4.229 10h15.546zM18.5 11.5a2 2 0 100 4 2 2 0 000-4zm-13 0a2 2 0 100 4 2 2 0 000-4zM15 13H9l-.09.008a.5.5 0 000 .984L9 14h6l.09-.008a.5.5 0 000-.984L15 13zm7.008-5l.092.007c.206.03.358.163.392.317l.008.067v.35l-.01.058a.246.246 0 01-.073.108.38.38 0 01-.19.087L22.15 9h-.938l-.294-1h1.09zM3.081 8l-.293 1h-.934l-.079-.006a.379.379 0 01-.192-.087.247.247 0 01-.074-.108L1.5 8.742v-.35l.008-.068c.034-.154.186-.286.392-.317L1.992 8H3.08zM6.609 4l.208.004h10.376l.223-.003c.294.007.567.067.824.176a1.5 1.5 0 01.619.575c.078.14.145.295.197.458l.047.164.386 1.324.492 1.65.202.687-.187-.024-.19-.012H4.212l-.199.013-.195.024.203-.69.49-1.646.419-1.293.052-.184c.056-.176.125-.334.208-.483.146-.242.368-.445.633-.573.24-.1.51-.159.786-.167zM7 20.064V18H4v2.078l.01.096c.066.38.472.716 1.024.804l.14.016.147.006h.358l.148-.006c.629-.05 1.101-.417 1.165-.833L7 20.064zm13 0V18h-3v2.064l.007.097c.058.386.457.727 1.001.816l.14.017.144.006h.416l.145-.006c.614-.05 1.077-.415 1.14-.833l.007-.097zm-.5-6.564a1 1 0 10-2 0 1 1 0 002 0zm-14-1a1 1 0 110 2 1 1 0 010-2z"
  }));
};
const SvgCarsBrand = styled(BaseComponent).withConfig({
  displayName: "CarsBrand__SvgCarsBrand",
  componentId: "sc-3vj8vk-0"
})(["outline:none;"]);
SvgCarsBrand.isIcon = true;
export default SvgCarsBrand;